// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{
		"id":0,
		"applicableObjects": 0,
		"chargeProjectName": "",
		"clinicId": 0,
		"coding": "",
		"description": "",
		"excludedContent": "",
		"expenseCategoryId": 1,
		"finClassCode": "",
		"financialClassId": 0,
		"measurementUnit": "",
		"medicalRecordCostId": 0,
		"oneCeilingPrice": 0,
		"operatingPeople": 0,
		// "operatingTime": "",
		"priceCode": "",
		"projectConnotation": "",
		"remake": "",
		"simpCode": "",
		"standardCode": "",
		"standardName": "",
		"state": "",
		"threeCeilingPrice": 0,
		"twoCeilingPrice": 0
	}
]

